import { useQuery, useMutation } from '@tanstack/react-query';
import { customFetch } from '@workspace/api-client-react';

const API_BASE = '/api';

async function apiFetch(path: string, opts?: RequestInit) {
  return customFetch(`${API_BASE}${path}`, {
    ...opts,
    headers: { 'Content-Type': 'application/json', ...opts?.headers },
    credentials: 'include',
  });
}

// ─── Products with prices ─────────────────────────────────────────────────────

export function useStripeProducts() {
  return useQuery({
    queryKey: ['stripe', 'products'],
    queryFn: () => apiFetch('/stripe/products'),
    staleTime: 5 * 60_000,
    retry: 1,
  });
}

// ─── Subscription status ──────────────────────────────────────────────────────

export function useSubscription() {
  return useQuery({
    queryKey: ['stripe', 'subscription'],
    queryFn: () => apiFetch('/stripe/subscription'),
    staleTime: 60_000,
    retry: 1,
  });
}

// ─── Create checkout session ──────────────────────────────────────────────────

export function useCreateCheckout() {
  return useMutation({
    mutationFn: async (priceId: string) => {
      const data = await apiFetch('/stripe/checkout', {
        method: 'POST',
        body: JSON.stringify({ priceId }),
      });
      return data as { url: string };
    },
  });
}

// ─── Customer portal ──────────────────────────────────────────────────────────

export function useOpenPortal() {
  return useMutation({
    mutationFn: async () => {
      const data = await apiFetch('/stripe/portal', { method: 'POST' });
      return data as { url: string };
    },
  });
}
